import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class HackerOne extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M8.382.3A2.151,2.151,0,0,0,7.226,0,2.122,2.122,0,0,0,6.035.3a.931.931,0,0,0-.462.794V22.876a1.021,1.021,0,0,0,.462.76A1.93,1.93,0,0,0,7.192,24a2,2,0,0,0,1.157-.364.975.975,0,0,0,.5-.76V1.087A.809.809,0,0,0,8.382.294m2.744,11.437a.912.912,0,0,0-.231.86,1.706,1.706,0,0,0,.525,1.087,2.118,2.118,0,0,0,1.057.661.976.976,0,0,0,.893-.132l1.752-1.088v9.752a1.021,1.021,0,0,0,.463.761A1.833,1.833,0,0,0,16.741,24a2.039,2.039,0,0,0,1.191-.364.973.973,0,0,0,.5-.761V9.719a.85.85,0,0,0-.5-.761,2.319,2.319,0,0,0-1.224-.3,2,2,0,0,0-1.156.3l-4.43,2.777" />
      </svg>
    );
  }
}

export default HackerOne;
